import React from 'react'
import injectSheet from 'react-jss'
import styles from './entry-skeleton.styles'
import { TableRow, Cell } from 'pobble-components/dist/table'
import Bone from 'pobble-components/dist/bone'

const EntrySkeleton = ({ classes, titleWidth = 80 }) => (
  <TableRow>
    <Cell>
      <Bone className={classes.date} />
    </Cell>
    <Cell>
      <Bone style={{ width: `${titleWidth}%` }} />
    </Cell>
  </TableRow>
)

export default injectSheet(styles)(EntrySkeleton)
